import React, { useEffect, useState, useRef } from "react";
import Navbar from "../components/Navbar.js";
import Footer from "../components/Footer.js";
import BannerImage from "../components/img/general-medicine-banner.png";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faChevronRight } from "@fortawesome/free-solid-svg-icons";
import axios from 'axios';
import "../styles/pages.css";
import { FaChevronRight, FaCircleArrowRight } from "react-icons/fa6";
import { useNavigate } from 'react-router-dom';

function GeneralMedicine () {
  const [activeSection, setActiveSection] = useState("overview");
  const [isFixed, setIsFixed] = useState(false);
  const sectionsRef = {
    overview: useRef(null),
    treatment: useRef(null),
    facilities: useRef(null),
    doctors: useRef(null),
  };
  const sidebarRef = useRef(null);
  const contentRef = useRef(null);
  const footerRef = useRef(null);

  const handleScroll = () => {
    const sections = ["overview", "treatment", "facilities", "doctors"];
    let currentSection = "";
    let setFix = false;
    for (let section of sections) {
      const ref = sectionsRef[section].current;
      const { top, bottom } = ref.getBoundingClientRect();
      const isInView =
        top <= window.innerHeight / 2 && bottom >= window.innerHeight / 2;
      if (top < 85) {
        setFix = true;
      } else {
        setFix = false;
      }
      if (isInView) {
        console.log("top", top, "bottom", bottom, "win", window.innerHeight);
        currentSection = section;
      }
    }
    setIsFixed(setFix);
    setActiveSection(currentSection);
  };

  const scrollToSection = (section) => {
    const sectionElement = sectionsRef[section].current;
    if (sectionElement) {
      const offsetTop = sectionElement.getBoundingClientRect().top + window.scrollY;
      const headerOffset = 100; // Adjust this value to match the height of your fixed header or sidebar
      window.scrollTo({
        top: offsetTop - headerOffset,
        behavior: "smooth",
      });
    }
  };

  useEffect(() => {
    handleScroll(); // Trigger once on load
    window.addEventListener("scroll", handleScroll);
  }, []);

  const [doctors, setDoctors] = useState([]);
  const [error, setError] = useState(null);
  const filteredDoctors = doctors.filter(doctor => doctor.department_name === "General Medicine");

  useEffect(() => {
    const fetchDoctors = async () => {
      try {
        const response = await axios.get(`https://caritasmathahospital.com/wp-content/themes/my_react_theme/api/get_doctors.php`);
        setDoctors(response.data);
      } catch (error) {
        console.error("Error fetching doctors:", error);
      }
    };
    fetchDoctors();
  }, []);

  const navigate = useNavigate();
  
  const handleDoctorClick = (doctor) => {
    navigate(`/doctor/${doctor.id}`, { state: { doctor } })
  };

  return (
    <div>

        {/* Navbar starts here  */}

            <Navbar />

        {/* Navbar ends here */}

        <section className="page-section">
            <div className="section-content">
                <p className='page-heading'>General Medicine</p>

                <div class="d-none d-md-block"> {/*Visible on desktop, hidden on mobile */}
                    <p className="page-subtitle">
                        Holistic Medical Care Addressing Diverse Health Concerns in 
                        <br/> 
                        General Medicine.
                    </p>
                </div>

                <div class="d-md-none mb-2"> {/* Visible on mobile, hidden on desktop */}
                    <p className="page-subtitle">
                        Holistic Medical Care Addressing Diverse Health Concerns in General Medicine.
                    </p>
                </div>

                <div className="page-box">
                    <div className="box-content">
                        <p>Caritas Matha Hospital's General Medicine department offers comprehensive care for various medical conditions. Our expert team provides personalized treatment plans and compassionate support, using advanced medical technologies and evidence-based practices to ensure the well-being and recovery of our patients.</p>
                    </div>
                    <div className="box-image">
                        <img src={BannerImage} alt="General Medicine Banner"/>
                    </div>
                </div>
            </div>
        </section>
        <section className="dept-section">
            <div
            ref={sidebarRef}
            className={`sidebar-title ${!isFixed ? "fixed" : ""}`}
            >
            {["overview", "treatment", "facilities", "doctors"].map((section) => (
                <p
                key={section}
                className={`title ${activeSection === section ? "active" : ""}`}
                onClick={() => scrollToSection(section)}
                >
                {section.charAt(0).toUpperCase() + section.slice(1)}
                {activeSection === section && (
                    <FontAwesomeIcon
                    icon={faChevronRight}
                    className="chevron-icon"
                    />
                )}
                </p>
            ))}
            </div>
            <div ref={contentRef} className="contents">
                <div ref={sectionsRef.overview} className="overview-content">
                    <p className="content-heading">Overview</p>
                    {/* Overview content here */}
                    <p>The General Medicine department at Caritas Matha Hospital offers comprehensive healthcare services for adults of all ages, focusing on the diagnosis, treatment, and management of a wide range of medical conditions. Our team of skilled internists and specialists is committed to providing personalized care with a strong emphasis on preventive medicine and holistic wellness.</p>

                    <p>In addition to primary and specialist care, our department emphasizes patient education and empowerment. We believe in equipping our patients with the knowledge and tools they need to manage their health effectively. Through educational programs, workshops, and personalized health plans, we encourage lifestyle modifications and preventive measures to promote long-term well-being.</p>

                    <p>At Caritas Matha Hospital, we integrate the latest medical advancements and technology into our practice. Our physicians have access to cutting-edge diagnostic tools and evidence-based treatments, ensuring that patients receive accurate diagnoses and effective therapies. Whether managing chronic conditions, addressing acute medical concerns, or providing comprehensive health screenings, our goal is to deliver compassionate care that meets the unique needs of each individual.</p>

                </div>
                <div ref={sectionsRef.treatment} className="treatment-content">
                    <p className="content-heading">Treatment</p>
                    {/* Treatment content here */}
                    
                    
                    <span className="sub-heading">Primary Care : </span>
                    <p></p>

                    <ul>
                        <li>
                          <span className="subtitle">Routine Check-ups : </span>Regular health assessments and screenings to monitor overall health and detect potential medical issues early.</li>
                        <br/>

                        <li>
                          <span className="subtitle">Chronic Disease Management : </span>Comprehensive care for chronic conditions such as diabetes, hypertension, asthma, and arthritis.</li>
                        <br/>

                        <li>
                          <span className="subtitle">Acute Illness Management : </span>Prompt diagnosis and treatment of acute illnesses such as respiratory infections, gastrointestinal disorders, and urinary tract infections.</li>
                        <br/>

                        <li>
                          <span className="subtitle">Pain Management : </span>Effective management of chronic pain conditions through multimodal approaches and pain relief therapies.</li>
                        <br/>
                    </ul>

                    <span className="sub-heading">Specialist Care : </span>
                    <p></p>

                    <ul>
                        <li>
                          <span className="subtitle">Cardiology : </span>Diagnosis and management of heart-related conditions including hypertension, coronary artery disease, and arrhythmias.</li>
                        <br/>

                        <li>
                          <span className="subtitle">Gastroenterology : </span>Treatment of digestive disorders such as gastritis, irritable bowel syndrome (IBS), and liver diseases.</li>
                        <br/>

                        <li>
                          <span className="subtitle">Endocrinology : </span>Management of hormonal disorders including thyroid disorders, diabetes mellitus, and adrenal gland disorders.</li>
                        <br/>

                        <li>
                          <span className="subtitle">Pulmonology : </span>Care for respiratory conditions such as asthma, COPD (Chronic Obstructive Pulmonary Disease), and pulmonary infections.</li>
                        <br/>

                        <li>
                          <span className="subtitle">Rheumatology : </span>Diagnosis and treatment of autoimmune diseases and musculoskeletal disorders like rheumatoid arthritis and lupus.</li>
                        <br/>

                        <li>
                          <span className="subtitle">Infectious Diseases : </span>Diagnosis and management of infectious diseases including viral, bacterial, and fungal infections.</li>
                        <br/>
                    </ul>

                </div>
                <div ref={sectionsRef.facilities} className="facilities-content">
                    <p className="content-heading">Facilities</p>
                    {/* Facilities content here */}

                    <br/>
                    <ul>
                        <li>
                          <span className="subtitle">Outpatient Clinics : </span>Conveniently located clinics for consultations, follow-up visits, and preventive health checks.</li>
                        <br/>

                        <li>
                          <span className="subtitle">Diagnostic Services : </span>Advanced diagnostic facilities including laboratory tests, imaging (X-ray, CT scan, MRI), and cardiac investigations.</li>
                        <br/>

                        <li>
                          <span className="subtitle">Day Care Services : </span>Outpatient procedures and treatments provided in a comfortable and monitored environment.</li>
                        <br/>

                        <li>
                          <span className="subtitle">Inpatient Care : </span>Well-equipped wards and private rooms for patients requiring hospitalization and intensive medical care.</li>
                        <br/>

                        <li>
                          <span className="subtitle">Intensive Care Unit (ICU) : </span>State-of-the-art ICU facilities for patients needing critical care and continuous monitoring.</li>
                        <br/>

                        <li>
                          <span className="subtitle">Emergency Services : </span>24/7 emergency care services for immediate medical attention and stabilization of acute medical conditions.</li>
                        <br/>

                        <li>
                          <span className="subtitle">Rehabilitation Services : </span>Comprehensive rehabilitation programs including physical therapy, occupational therapy, and cardiac rehabilitation.</li>
                        <br/>
                    </ul>        
                </div>

                <div ref={sectionsRef.doctors} className="doctors">
                    <p className="content-heading">Doctors</p>

                    {error && <p>{error}</p>}
                    {filteredDoctors.length > 0 ? (
                        <div className='doctorbox-container'>
                            {filteredDoctors.map(doctor => (
                                <div key={doctor.id} className="doctorbox">
                                  <div className="doctor-box">
                                      <img src={doctor.image_url} className='doctor-img' onClick={() => handleDoctorClick(doctor)} style={{ cursor: "pointer" }}/>
                                      <div className='doctor-details'>
                                          <h4 onClick={() => handleDoctorClick(doctor)} style={{ cursor: "pointer" }}>{doctor['name']}</h4>
                                          <p>{doctor['designation']}</p>
                                          <p>{ doctor.available_time }</p>
                                          <br/>
                                          {parseInt(doctor.appointment_enabled) === 1 && (
                                              <p>
                                                  <a href="https://booking.caritasmathahospital.com/OnlineAppointmentBooking/OnlineAppointmentBooking.aspx" target="_blank" rel="noopener noreferrer" >
                                                      Book An Appointment <FaChevronRight />
                                                  </a>
                                              </p>
                                          )}
                                      </div>
                                  </div>
                                  <div className='arrow-section'>
                                      <FaCircleArrowRight className='right-circle-arrow' onClick={() => handleDoctorClick(doctor)} style={{ cursor: "pointer" }}/>
                                  </div>
                                </div>
                            ))}
                        </div>
                    ) : (
                        !error && <p>No doctors available in this department.</p>
                    )}
                </div>
            </div>
        </section>

        {/* Footer Starts here */}

            <Footer ref={footerRef} />

        {/* Footer ends here */}
    </div>
  );
}

export default GeneralMedicine;